import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import addPlus from '@/utilities/addPlus';
import LootWeaponsProperties from '@/pages/Loot/LootWeaponsProperties.vue';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
let CharacterSheetWeapon = class CharacterSheetWeapon extends Vue {
    constructor() {
        super(...arguments);
        this.addPlus = addPlus;
    }
    get rootPath() {
        const equipmentType = this.weapon.isCustom ? 'customEquipment' : 'equipment';
        return this.weapon.name === 'Unarmed Strike' ? 'tweaks.unarmed' : `${equipmentType}.${this.weapon.index}.tweaks`;
    }
    get tweakPaths() {
        return [
            { name: 'Damage Dice', path: 'damageDice', type: 'dice' },
            { name: 'To Hit', path: 'toHit' },
            { name: 'Damage Bonus', path: 'damage' }
        ];
    }
    get damage() {
        const { damageNumberOfDice, damageDieType, damageBonus, damageType } = this.weapon;
        const hasDice = damageNumberOfDice && damageDieType;
        const damageModifier = damageBonus ? addPlus(damageBonus) : '';
        const damage = hasDice ? damageNumberOfDice + 'd' + damageDieType + damageModifier : damageBonus;
        return damage + ' ' + damageType;
    }
};
__decorate([
    Prop(Object)
], CharacterSheetWeapon.prototype, "weapon", void 0);
CharacterSheetWeapon = __decorate([
    Component({
        components: {
            LootWeaponsProperties,
            CharacterSheetTweaker
        }
    })
], CharacterSheetWeapon);
export default CharacterSheetWeapon;
